
import { makeStyles } from '@material-ui/core';

const useFaqStyles = makeStyles(() => ({
  accordionBlock: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "16px",
    alignSelf: "stretch"
  },
  accordionSummary: {
    display: "flex",
    gap: "16px",
    alignSelf: "stretch",
    marginTop:"8px !important",
    marginBottom: "8px !important",
    padding: "4px !important"
  },
  faqText: {
    color: "var(--neutrals-grey-900, #212121)",
    fontFamily: "Roboto !important",
    fontSize: "16px !important",
    fontStyle:"normal !important",
    fontWeight: 500,
    lineHeight: "22px !important"
  },
  title: {
    alignSelf: "stretch",
    color: "var(--neutrals-grey-900, #212121)",
    fontFamily: "Roboto",
    fontSize: "24px",
    fontStyle:"normal",
    fontWeight: 500,
    lineHeight: "34px"
  },
  faqBlock: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "24px",
    alignSelf:"stretch",
  },
  buttonWrapper: {
    textAlign: 'center'
  },
  faqWrapper: {
    display: "flex",
    width: "1240px",
    padding: "40px",
    flexDirection: "column",
    alignItems: "center",
    gap: "32px",
    borderRadius: "4px",
    background: "var(--neutrals-grey-00, #FFF)",
    boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.05), 0px 1px 10px 0px rgba(0, 0, 0, 0.05), 0px 4px 5px 0px rgba(0, 0, 0, 0.05)",
  },
  getStartedBtn: {
    display: "flex",
    width: "245px",
    height: "42px",
    padding: "8px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    borderRadius: "4px",
    background: "var(--primary-primary-500, #007DB8)",
    color: "var(--neutrals-grey-00, #FFF)",
    textAlign: "center",
    fontFamily: "Roboto",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px"
  },
}));

export default useFaqStyles;